// firebase
import { collection, setDoc, doc } from "firebase/firestore";
import { db } from "config/firebase";

// user-controller
import addSignature from "user-controller/addSignature";

// A ---------------------------------------------------------------------- M

const sendDataStreamConfig = async (isPublic, userID, dataBody, dataCertification, timestamp, databoxID) => {
  try {
    const txid = dataCertification.txid;
    const recordRef = doc(db, "recordsdata", txid);

    const recordData = {
      txid: txid,
      type: "cfg",
      ...(databoxID && { tdr: databoxID }),
      creator_uuid: userID,
      data: {
        jsonconfig: dataBody.jsonconfig,
        target: dataBody.target,
        timestamp: timestamp,
      },
      jsonconfig: dataBody.jsonconfig,
      target: dataBody.target,
      timestamp: timestamp,
      public: isPublic,
      version: 1,
    };

    console.log(recordData);

    await setDoc(recordRef, recordData);

    if (databoxID) {
      const tagRef = doc(db, "tagsdata", databoxID);
      const recordsRef = collection(tagRef, "signatures");

      const signatureData = {
        txid: txid,
        type: "cfg",
        creator_uuid: userID,
        jsonconfig: dataBody.jsonconfig,
        target: dataBody.target,
        timestamp: timestamp,
        public: isPublic,
        db_id: 1,
      };

      console.log(signatureData);

      await setDoc(doc(recordsRef, txid), signatureData);
    }

    databoxID ? await addSignature(userID, txid, timestamp, "cfg", databoxID) : await addSignature(userID, txid, timestamp, "cfg");

    const result = {
      txid: txid,
      success: true,
    };

    console.log(result);
    return result;
  } catch (error) {
    console.error("Error in sendDataStreamConfig:", error.message);

    const result = {
      success: false,
      error: error.message,
    };

    return result;
  }
};

export default sendDataStreamConfig;
